export default "__VITE_ASSET__ClZuzeFY__"